import { useEffect, useState } from "react";
import { toast } from "sonner";
import PageHeader from "../components/layout/PageHeader";
import { api, apiErrorMessage } from "../lib/api";
import { TID } from "../lib/testIds";
import ChatGPTLoginDialog from "../components/engines/ChatGPTLoginDialog";
import EngineList from "../components/engines/EngineList";
import AddEngineDialog from "../components/engines/AddEngineDialog";
import RunEngineDialog from "../components/engines/RunEngineDialog";

export default function EnginesPage() {
  const [engines, setEngines] = useState([]);
  const [adapters, setAdapters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [loginEngine, setLoginEngine] = useState(null);
  const [running, setRunning] = useState(null);

  const refresh = async () => {
    try {
      const [er, ar] = await Promise.all([
        api.get("/engine-registry"),
        api.get("/engine-registry/adapters"),
      ]);
      setEngines(er.data || []);
      setAdapters(ar.data || []);
    } catch (e) {
      toast.error(apiErrorMessage(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <div data-testid={TID.engines.root} className="space-y-6">
      <PageHeader
        eyebrow="Nuevo módulo · Fase A"
        title="Motores IA"
        description="Registro central de motores que KRAI API puede utilizar. Cada motor apunta a un adapter aislado."
      />

      <div className="rounded-md border border-zinc-800 bg-zinc-950/30 p-4 text-xs text-zinc-400 space-y-1">
        <div>
          Flujo runtime:{" "}
          <code className="text-zinc-300">
            App → KRAI API → /api/engine-router/execute → adapter → motor → respuesta
          </code>
        </div>
        <div>
          Autenticación del Router: <code className="text-zinc-300">Bearer KRAI_ROUTER_TOKEN</code> (variable de entorno).
        </div>
      </div>

      <EngineList
        engines={engines}
        adapters={adapters}
        loading={loading}
        onAdd={() => setEditing("new")}
        onEdit={(e) => setEditing(e)}
        onRun={(e) => setRunning(e)}
        onDeleted={refresh}
        onLogin={setLoginEngine}
        onDuplicate={async (engine) => {
          try {
            let n=2; while (engines.some((e) => e.id === `${engine.id.slice(0,50)}-${n}`)) n++;
            const id=`${engine.id.slice(0,50)}-${n}`;
            const profile=`chatgpt-${id.replace(/^chatgpt-/, "").slice(0,55)}`;
            await api.post("/engine-registry", {
              id, name:`${engine.name} · cuenta ${n}`, provider:engine.provider,
              adapter:engine.adapter, active:false, priority:engine.priority ?? 100,
              modes:engine.modes || [], capabilities:engine.capabilities || [],
              config:{...engine.config, profile},
              notes:"Perfil independiente. Completa el inicio de sesión para activarlo."
            });
            toast.success("Configuración duplicada. Inicia sesión en la nueva cuenta."); refresh();
          } catch (e) { toast.error(apiErrorMessage(e)); }
        }}
      />

      {editing && (
        <AddEngineDialog
          engine={editing === "new" ? null : editing}
          adapters={adapters}
          onClose={() => setEditing(null)}
          onSaved={() => { setEditing(null); refresh(); }}
        />
      )}

      {loginEngine && <ChatGPTLoginDialog engine={loginEngine} onClose={() => setLoginEngine(null)} onSaved={refresh} />}
      {running && (
        <RunEngineDialog
          engine={running}
          onClose={() => setRunning(null)}
        />
      )}
    </div>
  );
}
